module.exports = "<div class=\"form-group\">\n  <label class=\"label-control\">{{title}}</label>\n  <input type=\"text\"  #datePicker class=\"form-control datepicker\" [(ngModel)]=\"date\" (blur)=\"selectDateFromDTP(datePicker.value)\" />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/datetimepicker/datetimepicker.component.html
// module id = ./src/app/shared/datetimepicker/datetimepicker.component.html
// module chunks = main